// src/utils/constants.js

export const TRADER_LIST = ['prapor', 'therapist', 'skier', 'peacekeeper', 'mechanic', 'ragman', 'jaeger', 'ref', 'fence'];
export const TRADER_SORT_ORDER = [
    'prapor',
    'therapist',
    'skier',
    'peacekeeper',
    'mechanic',
    'ragman',
    'jaeger',
    'fence',
    'ref',
    'lightkeeper',
    'btr-driver'
];

export const EXCLUDED_TRADER_IDS = ['579dc571d53a0658a154fbec'];
export const EXCLUDED_TRADER_NAMES = ['Taran', 'Mr. Kerman', 'Voevoda', 'Radio station', 'Unknown'];

export const TRADER_COLORS = {
    'prapor': '#eab308',      // yellow-500
    'therapist': '#10b981',   // emerald-500
    'skier': '#3b82f6',       // blue-500
    'peacekeeper': '#06b6d4', // cyan-500
    'mechanic': '#a855f7',    // purple-500
    'ragman': '#f97316',      // orange-500
    'jaeger': '#65a30d',      // lime-600
    'fence': '#71717a',       // zinc-500
    'ref': '#ef4444',         // red-500
    'lightkeeper': '#f59e0b', // amber-500
    'btr driver': '#64748b',  // slate-500
    'btr-driver': '#64748b',  // slate-500
    'default': '#71717a'      // zinc-500
};
export const TRADER_FALLBACK_IMAGES = {
    'prapor': 'https://assets.tarkov.dev/trader-prapor.jpg',
    'therapist': 'https://assets.tarkov.dev/trader-therapist.jpg',
    'skier': 'https://assets.tarkov.dev/trader-skier.jpg',
    'peacekeeper': 'https://assets.tarkov.dev/trader-peacekeeper.jpg',
    'mechanic': 'https://assets.tarkov.dev/trader-mechanic.jpg',
    'ragman': 'https://assets.tarkov.dev/trader-ragman.jpg',
    'jaeger': 'https://assets.tarkov.dev/trader-jaeger.jpg',
    'fence': 'https://assets.tarkov.dev/trader-fence.jpg',
    'ref': 'https://assets.tarkov.dev/trader-ref.jpg',
    'lightkeeper': 'https://assets.tarkov.dev/trader-lightkeeper.jpg',
    'btr driver': 'https://assets.tarkov.dev/trader-btr.jpg',
    'default': 'https://assets.tarkov.dev/trader-fence.jpg' // Hiçbiri yoksa varsayılan
};
export const FENCE_THRESHOLDS = {
    'Wager': -1.0, 'Trust': -2.0, 'Barkeep': -2.0, 'Collection': -3.0, 'Wergild': -4.0, 'Compensation': -1.0,
    'Ставка': -1.0, 'Доверие': -2.0, 'Бармен': -2.0, 'Коллекция': -3.0, 'Вира': -4.0, 'Возмещение ущерба': -1.0
};

export const isQuestUnlocked = (quest, completedQuests = [], playerLevel = 1) => {
    if (quest.minPlayerLevel && playerLevel < quest.minPlayerLevel) return false;
    if (quest.taskRequirements && quest.taskRequirements.length > 0) {
        return quest.taskRequirements.every(req => completedQuests.includes(req.task.id));
    }
    return true;
};

export const isFenceQuestVisible = (quest, fenceRep = 0) => {
    if (quest.trader?.normalizedName !== 'fence') return true;

    const englishName = quest.englishName || quest.name || '';
    if (englishName === 'Establish Contact' && fenceRep < 4.0) return false;

    const thresholdEntry = Object.entries(FENCE_THRESHOLDS).find(([key]) => englishName.includes(key));
    if (!thresholdEntry) return true;

    const requiredRep = thresholdEntry[1];
    return fenceRep <= requiredRep;
};

export const getWikiLink = (quest, language = 'en') => {
    if (language === 'ru') {
        const formatted = quest.name.trim().replace(/ /g, '_');
        return `https://escapefromtarkov.fandom.com/ru/wiki/${formatted}`;
    }
    // For en/tr, use the English wikiLink from API, or construct from English name
    if (quest.wikiLink) return quest.wikiLink;
    const formatted = (quest.englishName || quest.name).trim().replace(/ /g, '_');
    return `https://escapefromtarkov.fandom.com/wiki/${formatted}`;
};
